import { render, staticRenderFns } from "./categ_mode.vue?vue&type=template&id=30fb4d0c&scoped=true&"
import script from "./categ_mode.vue?vue&type=script&lang=js&"
export * from "./categ_mode.vue?vue&type=script&lang=js&"
import style0 from "./categ_mode.vue?vue&type=style&index=0&id=30fb4d0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fb4d0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30fb4d0c')) {
      api.createRecord('30fb4d0c', component.options)
    } else {
      api.reload('30fb4d0c', component.options)
    }
    module.hot.accept("./categ_mode.vue?vue&type=template&id=30fb4d0c&scoped=true&", function () {
      api.rerender('30fb4d0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/categories/category/tabs/categ_mode.vue"
export default component.exports